__turbopack_context__.v({
  "link": "index-module-scss-module__B_w-cG__link",
});
